module.exports = __webpack_public_path__ + "static/media/banner-new-campaingn.dd0f03e6.png";